import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function EyeOffOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_128)'>
        <path
          d='M4.71019 3.28994C4.61695 3.1967 4.50626 3.12274 4.38443 3.07228C4.26261 3.02182 4.13204 2.99585 4.00019 2.99585C3.86833 2.99585 3.73776 3.02182 3.61594 3.07228C3.49411 3.12274 3.38342 3.1967 3.29019 3.28994C3.10188 3.47825 2.99609 3.73364 2.99609 3.99994C2.99609 4.26624 3.10188 4.52164 3.29019 4.70994L8.92019 10.3399C8.56399 11.0026 8.43077 11.7623 8.54027 12.5066C8.64978 13.2509 8.99617 13.9401 9.52812 14.472C10.0601 15.004 10.7493 15.3503 11.4935 15.4599C12.2378 15.5694 12.9976 15.4361 13.6602 15.0799L19.2902 20.7099C19.3831 20.8037 19.4937 20.8781 19.6156 20.9288C19.7375 20.9796 19.8682 21.0057 20.0002 21.0057C20.1322 21.0057 20.2629 20.9796 20.3848 20.9288C20.5066 20.8781 20.6172 20.8037 20.7102 20.7099C20.8039 20.617 20.8783 20.5064 20.9291 20.3845C20.9798 20.2627 21.006 20.132 21.006 19.9999C21.006 19.8679 20.9798 19.7372 20.9291 19.6154C20.8783 19.4935 20.8039 19.3829 20.7102 19.2899L4.71019 3.28994ZM12.0002 13.4999C11.6024 13.4999 11.2208 13.3419 10.9395 13.0606C10.6582 12.7793 10.5002 12.3978 10.5002 11.9999V11.9299L12.0602 13.4899L12.0002 13.4999Z'
          fill={color}
        />
        <path
          d='M12.2201 17C7.92007 17.1 5.10007 13.41 4.22007 12C4.84654 11.0007 5.59943 10.0865 6.46007 9.27999L5.00007 7.87C3.87139 8.93347 2.90448 10.1564 2.13007 11.5C2.0423 11.652 1.99609 11.8245 1.99609 12C1.99609 12.1755 2.0423 12.348 2.13007 12.5C2.76007 13.59 6.13007 19 12.0201 19H12.2701C13.3776 18.9671 14.4708 18.7404 15.5001 18.33L13.9201 16.75C13.3644 16.8962 12.7943 16.98 12.2201 17Z'
          fill={color}
        />
        <path
          d='M21.87 11.5C21.23 10.39 17.7 4.81999 11.73 4.99999C10.6225 5.03285 9.52924 5.25961 8.5 5.66999L10.08 7.24999C10.6356 7.10382 11.2058 7.01997 11.78 6.99999C16.07 6.88999 18.89 10.59 19.78 12C19.1381 13.0023 18.3682 13.9167 17.49 14.72L19 16.13C20.1428 15.0693 21.1234 13.8462 21.91 12.5C21.9918 12.3445 22.0311 12.1702 22.0241 11.9946C22.0171 11.8191 21.9639 11.6485 21.87 11.5Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_128'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
